/**
* 头部菜单
*/
<template>
  <el-menu class="el-menu-demo tb-top-nav" mode="horizontal" background-color="transparent" text-color="#5d7090" active-text-color="#409eff">
    <el-button class="buttonimg" @click="toggle(collapsed)">
      <i class="el-icon-s-fold tb-fold-icon" v-if="!collapsed"></i>
      <i class="el-icon-s-unfold tb-fold-icon" v-else></i>
    </el-button>
    <div class="tb-top-title">
      <div class="tb-title-main">
        <span class="tb-dot"></span>
        <div class="tb-title-text">
          <span class="tb-title-name">YIJIU Control Center</span>
          <span class="tb-title-desc">数据中枢 · 实时监控 · 智能调度</span>
        </div>
      </div>
      <div class="tb-header-status">
        <span class="tb-header-pill">SYSTEM ONLINE</span>
        <span class="tb-time">{{ nowTime }}</span>
      </div>
    </div>
    <el-submenu index="2" class="submenu">
      <template slot="title">
        <span class="tb-avatar"></span>
        <span class="tb-username">{{ user.username || '超级管理员' }}</span>
      </template>
      <el-menu-item @click="exit()" index="2-3">退出登录</el-menu-item>
    </el-submenu>
  </el-menu>
</template>
<script>
import { loginout } from '../api/userMG'
export default {
  name: 'navcon',
  data() {
    return {
      collapsed: true,
      imgshow: require('../assets/img/show.png'),
      imgsq: require('../assets/img/sq.png'),
      user: {},
      nowTime: '',
      timer: null
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.user = JSON.parse(localStorage.getItem('userdata'))
    this.updateTime()
    this.timer = setInterval(this.updateTime, 1000)
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    updateTime() {
      const d = new Date()
      const pad = n => (n < 10 ? '0' + n : n)
      this.nowTime = `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
    // 退出登录
    exit() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          setTimeout(() => {
            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '已退出登录!'
            })
          }, 1000)
          // loginout()
          //   .then(res => {
          //     if (res.success) {
          //       //如果请求成功就让他2秒跳转路由
          //       setTimeout(() => {
          //         this.$store.commit('logout', 'false')
          //         this.$router.push({ path: '/login' })
          //         this.$message({
          //           type: 'success',
          //           message: '已退出登录!'
          //         })
          //       }, 1000)
          //     } else {
          //       this.$message.error(res.msg)
          //       this.logining = false
          //       return false
          //     }
          //   })
          //   .catch(err => {
          //     // 获取图形验证码
          //     this.getcode()
          //     this.logining = false
          //     this.$message.error('退出失败，请稍后再试！')
          //   })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype
      this.$root.Bus.$emit('toggle', this.collapsed)
    }
  }
}
</script>
<style scoped>
.tb-top-nav.el-menu-demo {
  height: 72px;
  line-height: 72px;
  display: flex;
  align-items: center;
  padding: 0 22px 0 10px;
  border: none !important;
  position: relative;
}
.tb-top-nav::after {
  content: '';
  position: absolute;
  left: 0; right: 0; bottom: 0; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(79, 140, 255, 0.45), transparent);
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}
.submenu { margin-left: auto; }

.buttonimg {
  height: 48px;
  width: 48px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(247, 250, 255, 0.96)) !important;
  border: 1px solid rgba(79, 140, 255, 0.16) !important;
  border-radius: 14px !important;
  padding: 0 !important;
  display: flex; align-items: center; justify-content: center;
  box-shadow:
    0 8px 18px rgba(37, 99, 235, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.92);
}
.tb-fold-icon {
  font-size: 22px;
  color: #6b7f9f;
  transition: all .25s;
}
.buttonimg:hover .tb-fold-icon {
  color: #409eff;
  text-shadow: 0 0 10px rgba(79, 140, 255, 0.35);
  transform: scale(1.08);
}
.buttonimg:hover {
  border-color: rgba(64, 158, 255, 0.3) !important;
  box-shadow:
    0 12px 24px rgba(37, 99, 235, 0.12),
    0 0 0 4px rgba(64, 158, 255, 0.08);
  transform: translateY(-2px);
}

/* 中间标题 */
.tb-top-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  flex: 1;
  margin-left: 14px;
  color: #5d7090;
  min-width: 0;
}
.tb-title-main {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.tb-title-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 1.2;
}
.tb-title-name {
  color: #22324a;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1.6px;
}
.tb-title-desc {
  color: rgba(93, 112, 144, 0.76);
  font-size: 11px;
  letter-spacing: 1px;
  margin-top: 4px;
}
.tb-dot {
  width: 8px; height: 8px;
  border-radius: 50%;
  background: #409eff;
  box-shadow: 0 0 8px rgba(64, 158, 255, 0.45);
  animation: tb-blink 1.6s ease-in-out infinite;
}
.tb-header-status {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
}
.tb-header-pill {
  display: inline-flex;
  align-items: center;
  height: 28px;
  padding: 0 12px;
  border-radius: 999px;
  border: 1px solid rgba(79, 140, 255, 0.18);
  background: linear-gradient(90deg, rgba(64, 158, 255, 0.14), rgba(79, 140, 255, 0.04));
  color: #2563eb;
  font-size: 11px;
  letter-spacing: 1.4px;
  box-shadow: 0 0 12px rgba(64, 158, 255, 0.10);
}
.tb-time {
  padding: 0 12px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  color: #409eff;
  border: 1px solid rgba(79, 140, 255, 0.24);
  border-radius: 999px;
  font-family: Consolas, "Courier New", monospace;
  background: rgba(64, 158, 255, 0.08);
}

/* 用户区 */
.tb-avatar {
  display: inline-block;
  width: 28px; height: 28px;
  border-radius: 50%;
  margin-right: 8px;
  vertical-align: middle;
  background: linear-gradient(135deg, #2563eb, #69b1ff);
  box-shadow: 0 0 10px rgba(64, 158, 255, 0.28);
  position: relative;
}
.tb-avatar::after {
  content: '';
  position: absolute;
  right: -2px; bottom: -2px;
  width: 8px; height: 8px;
  border-radius: 50%;
  background: #7dd3fc;
  box-shadow: 0 0 6px rgba(125, 211, 252, 0.55);
  border: 1px solid #ffffff;
}
.tb-username {
  color: #22324a;
  letter-spacing: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/navcon.vue